<template>
    <div>
        <OverviewStats :cards="cards" />
        <div class="card modern-page-card mt-4">
            <div class="card-header border-bottom">
                <h5 class="mb-1">حركة الصرف آخر 6 شهور</h5>
                <p class="text-muted small mb-0">الرسم يعتمد على WarehouseStockMovements.</p>
            </div>
            <div class="card-body">
                <div ref="movementChart" style="min-height:300px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatisticsTab',
    props: {
        statistics: { type: Object, default: () => ({}) }
    },
    computed: {
        cards() {
            return [
                { title: 'إجمالي الرصيد', value: this.formatNumber(this.statistics.totalBalance), color: 'primary', icon: 'ti ti-box' },
                { title: 'قيمة المخزون', value: `${this.formatNumber(this.statistics.stockValue)} د.ل`, color: 'success', icon: 'ti ti-currency-dollar' },
                { title: 'عدد الدفعات', value: this.formatNumber(this.statistics.batchCount), color: 'info', icon: 'ti ti-layers-subtract' }
            ];
        }
    },
    watch: {
        statistics: {
            deep: true,
            immediate: true,
            handler() {
                this.$nextTick(() => this.renderChart());
            }
        }
    },
    beforeDestroy() {
        if (this.chart) this.chart.destroy();
    },
    methods: {
        formatNumber(value) {
            return Number(value || 0).toLocaleString('ar');
        },
        renderChart() {
            if (!this.$refs.movementChart || typeof window.ApexCharts === 'undefined') return;
            if (this.chart) this.chart.destroy();

            const rows = this.statistics.monthlyMovements || [];
            const labels = rows.map(x => x.month || x.Month || '');
            const values = rows.map(x => x.quantity || x.Quantity || 0);

            this.chart = new window.ApexCharts(this.$refs.movementChart, {
                chart: { type: 'area', height: 300, toolbar: { show: false } },
                series: [{ name: 'الكمية', data: values }],
                xaxis: { categories: labels },
                colors: ['#7367F0'],
                stroke: { curve: 'smooth', width: 2 },
                fill: { type: 'gradient', gradient: { opacityFrom: 0.45, opacityTo: 0.08 } },
                dataLabels: { enabled: false },
                grid: { borderColor: 'rgba(115,103,240,0.12)' }
            });
            this.chart.render();
        }
    }
};
</script>
